module.exports = __webpack_public_path__ + "img/members_menu_img_04.17ff08ff.png";